//
//
//
//
//
//
//
//
//
//
//
//
//


import { asyncDataCatch, asyncDataStart } from '~/utils/asyncData'
import { Breadcrumbs } from '~/plugins/breadcrumbs'

export default {
  name: 'Privacy',
  async asyncData (ctx) {
    await asyncDataStart(ctx)

    try {
      let page = null
      const lang = ctx.store.getters['lang/locale']
      const { data } = await ctx.$axios.get('/api/content-page?link=privacy&lang=' + lang)
      page = data

      const crubms = Breadcrumbs.get(ctx.app.i18n, 'page', ctx.route, [{
        title: ctx.app.i18n.t('digital-flotilla'),
        url: ctx.route.fullPath
      }])
      await ctx.store.dispatch('setBreadcrumbs', crubms)

      if (Object.keys(page).length === 0) {
        ctx.error({ statusCode: 404, message: 'Page not found' })
        return
      }

      return {
        lang,
        page
      }
    } catch (e) {
      return asyncDataCatch(ctx, e)
    }
  },
  data () {
    return {
      filter: 'all'
    }
  },
  head () {
    return {
      title: this.page.data.meta_title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.page.data.meta_descrtiption
        }
      ]
    }
  }
}
